import axios from 'axios'

export function getTerms(locale, sailPackageCode) {
  return axios({
    method: 'GET',
    url: 'api/sales-static/confirmation-terms',
    params: { locale, sailpackage: sailPackageCode },
  })
}
